var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0259 12.8475L17.595 16.4158L16.4159 17.595L12.8475 14.0258C11.5198 15.0902 9.86835 15.6691 8.16669 15.6667C4.02669 15.6667 0.666687 12.3067 0.666687 8.16667C0.666687 4.02667 4.02669 0.666672 8.16669 0.666672C12.3067 0.666672 15.6667 4.02667 15.6667 8.16667C15.6691 9.86834 15.0902 11.5198 14.0259 12.8475ZM12.3542 12.2292C13.4118 11.1416 14.0024 9.6837 14 8.16667C14 4.94334 11.3892 2.33334 8.16669 2.33334C4.94335 2.33334 2.33335 4.94334 2.33335 8.16667C2.33335 11.3892 4.94335 14 8.16669 14C9.68371 14.0024 11.1416 13.4118 12.2292 12.3542L12.3542 12.2292Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.021dd191accc45e1cf959360c1ccb177.svg";
export { ForwardRef as ReactComponent };